
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const VideoPlayerComponent = lazy(() => import('./containers/VideoPlayerPageContainer'));

const route = [
  {
    path: ROUTERS.VIDEO_RECOMMEND_PLAYER,
    title: 'Video player',
    exact: true,
    public: false,
    component: <VideoPlayerComponent />
  },
];

export default route;
